var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.1 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.6,
    cy: 22.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,7.9c-1.1-1.1-2.8-1.1-3.9,0c-8,8-8,21.1,0,29.2c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8 c1.1-1.1,1.1-2.8,0-3.9c-5.9-5.9-5.9-15.5,0-21.4C20.9,10.7,20.9,9,19.9,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.2,7.9c-1.1-1.1-2.8-1.1-3.9,0c-1.1,1.1-1.1,2.8,0,3.9c5.9,5.9,5.9,15.5,0,21.4c-1.1,1.1-1.1,2.8,0,3.9 c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8C53.2,29,53.2,16,45.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,0.9c-1.1,1.1-1.1,2.8,0,3.9c9.8,9.7,9.8,25.7,0,35.5c-1.1,1.1-1.1,2.8,0,3.9c0.5,0.5,1.2,0.8,1.9,0.8 s1.4-0.3,1.9-0.8c12-12,12-31.4,0.1-43.3C51.1-0.2,49.4-0.2,48.3,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,4.7c1.1-1.1,1.1-2.8,0-3.9s-2.8-1.1-3.9,0C-3,12.7-3,32.1,8.9,44.1c0.5,0.5,1.2,0.8,1.9,0.8 s1.4-0.3,1.9-0.8c1.1-1.1,1.1-2.8,0-3.9C3,30.5,3,14.5,12.8,4.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorIcon);
export default __webpack_public_path__ + "static/media/sensor-icon.af3c085584de0ebc3085b999d1278a00.svg";
export { ForwardRef as ReactComponent };